import React, { useState } from "react";
import { useNavigate, useLocation } from 'react-router';
import { CircleUserRound, Lock } from "lucide-react";
import { Button, Input } from '@shared/components';
import useAuth from '../hooks/useAuth';
import styles from './LoginForm.module.css';

function LoginForm() {
  const navigate = useNavigate();
  const location = useLocation();

  const { login, isLoading, error } = useAuth();
  const [formData, setFormData] = useState({
    "email": '',
    "password": '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await login(formData.email, formData.password);
    if (success) {
      const from = location.state?.from;
      const isInternal = from?.pathname?.startsWith('/') && !from.pathname.startsWith('//') && from.pathname !== '/login';
      navigate(isInternal ? { pathname: from.pathname, search: from.search, hash: from.hash } : '/home', { replace: true });
    }
  };

  return (
    <form className={styles.formContainer} onSubmit={handleSubmit} >
      <div className={styles.inputContainer}>
        <CircleUserRound color={`var(--color-deep)`} />
        <Input
          type="email"
          name="email"
          label="E-mail"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Enter your e-mail"
        />
      </div>
      <div className={styles.inputContainer} style={{ marginBottom: "2rem" }}>
        <Lock color={`var(--color-deep)`} />
        <Input
          type="password"
          name="password"
          label="Password"
          value={formData.password}
          onChange={handleChange}
          required
          placeholder="Enter your password"
        />
      </div>
      {error && <div className={styles.errorMessage}>{error}</div>}
      <Button type="submit" loading={isLoading}>
        Sign In
      </Button>
    </form>
  );
};

export default LoginForm;